export default {
  allDashboards: [],
}
